export const formatAMPMTime = (dt) => {
    let month = dt.getMonth() + 1
    let getDate = (dt.getDate() + '/' + month + '/' + dt.getFullYear() + ' ' + dt.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }));
    return getDate;
}

export const formatTime = (dt) => {
    let month = dt.getMonth() + 1
    let Date = (dt.getDate() + '/' + month + '/' + dt.getFullYear() + ' ' + dt.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: false }));
    return Date;
}